import React from "react";
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { NavOptions, TableGenericViewController, TableGenericViewControllerDelegate } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { AdminProcessViewController, AdminProcessViewControllerDelegate } from "../../Screen/AdminProcess/AdminProcessViewController";
import { AdminProcessViewModel } from "../../Screen/AdminProcess/AdminProcessViewModel";
import { TableGenericFilter } from "../TableGeneric/TableGenericInteractor";
import ProtectedRoute from '../../Components/ProtectedRoute';
import { PermissionWrapper } from "../../Funcoes/PermissionWrapper";


export class AdminProcessCoordinator implements IndexCoordinatorDelegate, TableGenericViewControllerDelegate, AdminProcessViewControllerDelegate {
    private pointType: string
    constructor() {
        this.pointType = ""
    }
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm(),
            this.routeTableChildreen(),
            this.routeFormChildreen(),
            this.routeTablePoint(),
            this.routeFormPoint(),
            this.routeTableProperty(),
            this.routeFormProperty(),
            this.routeTablePropertyBuilding(),
            this.routeFormPropertyBuilding()
        ]
    }
    //Menu
    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepprocessoadministrativo")
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.*']} path="/:base/processo-administrativo" exact={true} component={(props: any) => {
            var filter = new TableGenericFilter('Origem', "NULL")
            const requiredPerms = ["acao.proc_adm.visita.ver"]

            return (
                <PermissionWrapper requiredPermissions={requiredPerms} delegate={this}>{(permissions, delegate) => {
                    var arrayOptions = new Array<NavOptions>()

                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocuments(navigation, item),
                        isSelection: true
                    })

                    arrayOptions.push({
                        title: "Movimentar Processo",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerMovement(navigation, item, component),
                        isSelection: true
                    })

                    arrayOptions.push({
                        title: "Subprocessos",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerSubprocess(navigation, item, component),
                        isSelection: true
                    })
                    if (permissions['acao.proc_adm.visita.ver'] === true) {
                        arrayOptions.push({
                            title: "Visitas",
                            action: (navigation: any, item: any, component: React.Component) => delegate.routerVisit(navigation, item, component),
                            isSelection: true
                        })
                    }
                    return (<TableGenericViewController
                        permissions={{
                            add: 'proc_admin.proc_admin.adicionar',
                            edit: 'proc_admin.proc_admin.editar',
                            delete: 'proc_admin.proc_admin.excluir',
                        }}
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Processo Administrativo"}
                        options={arrayOptions}
                        filter={[filter]}
                    />)
                }}

                </PermissionWrapper>
            )
        }} />)
    }
    //Menu form
    private routeForm(): JSX.Element {
        var viewModel = new AdminProcessViewModel()
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.adicionar', 'proc_admin.proc_admin.editar']} path="/:base/processo-administrativo/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<AdminProcessViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }
    //Quando seleciona um ponto
    private routeTablePoint(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepprocessoadministrativo")
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.*']} path="/:base/shape/tipo/:tipo/:id/tipo-vetor/:vetor/processo-administrativo" exact={true} component={(props: any) => {
            var filterSource = new TableGenericFilter('Origem', "NULL")
            var filterPoint = new TableGenericFilter('Shape', props.match.params.id)
            var typePoint = props.match.params.tipo
            var vetorType = props.match.params.vetor

            const requiredPerms = [
                'acao.ponto.urbano.proc_adm.adicionar',
                'acao.ponto.urbano.proc_adm.editar',
                'acao.ponto.urbano.proc_adm.excluir',

                'acao.ponto.rural.proc_adm.adicionar',
                'acao.ponto.rural.proc_adm.editar',
                'acao.ponto.rural.proc_adm.excluir',

                'acao.ponto.cemiterio.proc_adm.adicionar',
                'acao.ponto.cemiterio.proc_adm.editar',
                'acao.ponto.cemiterio.proc_adm.excluir',

                'acao.ponto.diverso.proc_adm.adicionar',
                'acao.ponto.diverso.proc_adm.editar',
                'acao.ponto.diverso.proc_adm.excluir',

                'acao.vetor.ponto.proc_adm.adicionar',
                'acao.vetor.ponto.proc_adm.editar',
                'acao.vetor.ponto.proc_adm.excluir',

                'acao.vetor.linha.proc_adm.adicionar',
                'acao.vetor.linha.proc_adm.editar',
                'acao.vetor.linha.proc_adm.excluir',

                'acao.vetor.poligono.proc_adm.adicionar',
                'acao.vetor.poligono.proc_adm.editar',
                'acao.vetor.poligono.proc_adm.excluir',

                'acao.proc_adm.visita.ver'

            ]
            return (
                <PermissionWrapper requiredPermissions={requiredPerms} delegate={this}>{(permissions, delegate) => {
                    var arrayOptions = new Array<NavOptions>()

                    let actionPerms = {
                        add: true,
                        edit: true,
                        del: true,
                    }

                    if ((permissions["acao.ponto.urbano.proc_adm.adicionar"] == false && typePoint === 'U') ||
                        (permissions["acao.ponto.rural.proc_adm.adicionar"] == false && typePoint === 'R') ||
                        (permissions["acao.ponto.cemiterio.proc_adm.adicionar"] == false && typePoint === 'C') ||
                        (permissions["acao.ponto.diverso.proc_adm.adicionar"] == false && typePoint === 'D') ||
                        (permissions["acao.vetor.ponto.proc_adm.adicionar"] == false && vetorType == "Point" && (typePoint === null || typePoint === "null")) ||
                        (permissions["acao.vetor.linha.proc_adm.adicionar"] == false && (vetorType == "MultiLineString" || vetorType == "LineString" || vetorType == "Line")) ||
                        (permissions["acao.vetor.poligono.proc_adm.adicionar"] == false && (vetorType == "Polygon" || vetorType == "MultiPolygon"))
                    ) {
                        actionPerms.add = false;
                    }

                    if (permissions["acao.ponto.urbano.proc_adm.editar"] == false && typePoint === 'U' ||
                        permissions["acao.ponto.rural.proc_adm.editar"] == false && typePoint === 'R' ||
                        permissions["acao.ponto.cemiterio.proc_adm.editar"] == false && typePoint === 'C' ||
                        permissions["acao.ponto.diverso.proc_adm.editar"] == false && typePoint === 'D' ||
                        permissions["acao.vetor.ponto.proc_adm.editar"] == false && vetorType == "Point" && (typePoint === null || typePoint === "null") ||
                        permissions["acao.vetor.linha.proc_adm.editar"] == false && (vetorType == 'MultiLineString' || vetorType == "LineString" || vetorType == "Line") ||
                        permissions["acao.vetor.poligono.proc_adm.editar"] == false && (vetorType == 'Polygon' || vetorType == "MultiPolygon")) {
                        actionPerms.edit = false
                    }
                    if (permissions["acao.ponto.urbano.proc_adm.excluir"] == false && typePoint === 'U' ||
                        permissions["acao.ponto.rural.proc_adm.excluir"] == false && typePoint === 'R' ||
                        permissions["acao.ponto.cemiterio.proc_adm.excluir"] == false && typePoint === 'C' ||
                        permissions["acao.ponto.diverso.proc_adm.excluir"] == false && typePoint === 'D' ||
                        permissions["acao.vetor.ponto.proc_adm.excluir"] == false && vetorType == "Point" && (typePoint === null || typePoint === "null") ||
                        permissions["acao.vetor.linha.proc_adm.excluir"] == false && (vetorType == 'MultiLineString' || vetorType == "LineString" || vetorType == "Line") ||
                        permissions["acao.vetor.poligono.proc_adm.excluir"] == false && (vetorType == 'Polygon' || vetorType == "MultiPolygon")) {
                        actionPerms.del = false
                    }
                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocuments(navigation, item),
                        isSelection: true
                    })

                    arrayOptions.push({
                        title: "Movimentar Processo",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerMovement(navigation, item, component),
                        isSelection: true
                    })

                    arrayOptions.push({
                        title: "Subprocessos",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerSubprocess(navigation, item, component),
                        isSelection: true
                    })
                    if (permissions['acao.proc_adm.visita.ver'] == true) {
                        arrayOptions.push({
                            title: "Visitas",
                            action: (navigation: any, item: any, component: React.Component) => delegate.routerVisit(navigation, item, component),
                            isSelection: true
                        })
                    }

                    return (<TableGenericViewController
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Processo Administrativo"}
                        options={arrayOptions}
                        filter={[filterSource, filterPoint]}
                        actionPerms={actionPerms}
                    />)
                }}
                </PermissionWrapper>
            )
        }} />)
    }

    private routeFormPoint(): JSX.Element {
        var viewModel = new AdminProcessViewModel()
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.adicionar', 'proc_admin.proc_admin.editar']} path="/:base/shape/:idPoint/processo-administrativo/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            var idPoint = props.match.params.idPoint
            return (<AdminProcessViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idShape={idPoint}
            />)

        }} />)
    }
    //Propriedade
    private routeTableProperty(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepprocessoadministrativo")
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.*']} path="/:base/propriedade/:id/tipo/:tipo/processo-administrativo" exact={true} component={(props: any) => {
            var filterSource = new TableGenericFilter('Origem', "NULL")
            var filterProperty = new TableGenericFilter('Propriedade', props.match.params.id)
            var typePoint = props.match.params.tipo
            const requiredPerms = [
                "acao.hist_prop.urbano.proc_adm.adicionar",
                "acao.hist_prop.urbano.proc_adm.editar",
                "acao.hist_prop.urbano.proc_adm.excluir",

                "acao.hist_prop.rural.proc_adm.adicionar",
                "acao.hist_prop.rural.proc_adm.editar",
                "acao.hist_prop.rural.proc_adm.excluir",

                "acao.hist_prop.cemiterio.proc_adm.adicionar",
                "acao.hist_prop.cemiterio.proc_adm.editar",
                "acao.hist_prop.cemiterio.proc_adm.excluir",

                "acao.hist_prop.diverso.proc_adm.adicionar",
                "acao.hist_prop.diverso.proc_adm.editar",
                "acao.hist_prop.diverso.proc_adm.excluir",
            ]

            return (
                <PermissionWrapper requiredPermissions={requiredPerms} delegate={this}>{(permissions, delegate) => {
                    var arrayOptions = new Array<NavOptions>()

                    let actionPerms = {
                        add: true,
                        edit: true,
                        del: true,
                    }
                    if (permissions["acao.hist_prop.urbano.proc_adm.adicionar"] == false && typePoint === 'U' ||
                        permissions["acao.hist_prop.rural.proc_adm.adicionar"] == false && typePoint === 'R' ||
                        permissions["acao.hist_prop.cemiterio.proc_adm.adicionar"] == false && typePoint === 'C' ||
                        permissions["acao.hist_prop.diverso.proc_adm.adicionar"] == false && typePoint === 'D') {
                        actionPerms.add = false
                    }
                    if (permissions["acao.hist_prop.urbano.proc_adm.editar"] == false && typePoint === 'U' ||
                        permissions["acao.hist_prop.rural.proc_adm.editar"] == false && typePoint === 'R' ||
                        permissions["acao.hist_prop.cemiterio.proc_adm.editar"] == false && typePoint === 'C' ||
                        permissions["acao.hist_prop.diverso.proc_adm.editar"] == false && typePoint === 'D') {
                        actionPerms.edit = false
                    }
                    if (permissions["acao.hist_prop.urbano.proc_adm.excluir"] == false && typePoint === 'U' ||
                        permissions["acao.hist_prop.rural.proc_adm.excluir"] == false && typePoint === 'R' ||
                        permissions["acao.hist_prop.cemiterio.proc_adm.excluir"] == false && typePoint === 'C' ||
                        permissions["acao.hist_prop.diverso.proc_adm.excluir"] == false && typePoint === 'D') {
                        actionPerms.del = false
                    }

                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocuments(navigation, item),
                        isSelection: true
                    })

                    arrayOptions.push({
                        title: "Movimentar Processo",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerMovement(navigation, item, component),
                        isSelection: true
                    })

                    arrayOptions.push({
                        title: "Subprocessos",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerSubprocess(navigation, item, component),
                        isSelection: true
                    })
                    if (permissions["acao.vetor.poligono.proc_adm.ver"] === true) {
                        arrayOptions.push({
                            title: "Visitas",
                            action: (navigation: any, item: any, component: React.Component) => delegate.routerVisit(navigation, item, component),
                            isSelection: true
                        })
                    }

                    return (<TableGenericViewController
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Processo Administrativo"}
                        options={arrayOptions}
                        filter={[filterSource, filterProperty]}
                        actionPerms={actionPerms}
                    />)
                }}
                </PermissionWrapper>
            )
        }} />)
    }
    //Propriedade
    private routeFormProperty(): JSX.Element {
        var viewModel = new AdminProcessViewModel()
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.*']} path="/:base/propriedade/:idProperty/processo-administrativo/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            var idProperty = props.match.params.idProperty
            return (<AdminProcessViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idProperty={idProperty}
            />)
        }} />)
    }
    //Edificacao
    private routeTablePropertyBuilding(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepprocessoadministrativo")
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.*']} path="/:base/edificacao/tipo/:tipo/:id/processo-administrativo" exact={true} component={(props: any) => {
            var filterSource = new TableGenericFilter('Origem', "NULL")
            var filterPropertyBuilding = new TableGenericFilter('Edificação', props.match.params.id)
            var pointType = props.match.params.tipo

            const requiredPermissions = [
                'acao.edif.urbano.proc_adm.adicionar',
                'acao.edif.urbano.proc_adm.editar',
                'acao.edif.urbano.proc_adm.excluir',

                'acao.edif.rural.proc_adm.adicionar',
                'acao.edif.rural.proc_adm.editar',
                'acao.edif.rural.proc_adm.excluir',

                'acao.edif.cemiterio.proc_adm.adicionar',
                'acao.edif.cemiterio.proc_adm.editar',
                'acao.edif.cemiterio.proc_adm.excluir'
            ]

            return (
                <PermissionWrapper requiredPermissions={requiredPermissions} delegate={this}>{(permissions, delegate) => {
                    var arrayOptions = new Array<NavOptions>()

                    let actionPerms = {
                        add: true,
                        edit: true,
                        del: true,
                    }
                    if (permissions["acao.edif.urbano.proc_adm.adicionar"] == false && pointType === 'U' ||
                        permissions["acao.edif.rural.proc_adm.adicionar"] == false && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.proc_adm.adicionar"] == false && pointType === 'C') {
                        actionPerms.add = false
                    }
                    if (permissions["acao.edif.urbano.proc_adm.editar"] == false && pointType === 'U' ||
                        permissions["acao.edif.rural.proc_adm.editar"] == false && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.proc_adm.editar"] == false && pointType === 'C') {
                        actionPerms.edit = false
                    }
                    if (permissions["acao.edif.urbano.proc_adm.excluir"] == false && pointType === 'U' ||
                        permissions["acao.edif.rural.proc_adm.excluir"] == false && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.proc_adm.excluir"] == false && pointType === 'C') {
                        actionPerms.del = false
                    }


                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocuments(navigation, item),
                        isSelection: true
                    })

                    arrayOptions.push({
                        title: "Movimentar Processo",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerMovement(navigation, item, component),
                        isSelection: true
                    })

                    arrayOptions.push({
                        title: "Subprocessos",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerSubprocess(navigation, item, component),
                        isSelection: true
                    })
                    arrayOptions.push({
                        title: "Visitas",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerVisit(navigation, item, component),
                        isSelection: true
                    })
                    return (<TableGenericViewController
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Processo Administrativo"}
                        options={arrayOptions}
                        filter={[filterSource, filterPropertyBuilding]}
                        actionPerms={actionPerms}
                    />)

                }}
                </PermissionWrapper>
            )
        }} />)
    }
    //Edificacao
    private routeFormPropertyBuilding(): JSX.Element {
        var viewModel = new AdminProcessViewModel()
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.adicionar', 'proc_admin.proc_admin.editar']} path="/:base/edificacao/:idPropertyBuilding/processo-administrativo/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            var idPropertyBuilding = props.match.params.idPropertyBuilding
            return (<AdminProcessViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idPropertyBuilding={idPropertyBuilding}
            />)
        }} />)
    }
    //Subprocesso
    private routeTableChildreen(): JSX.Element {
        var arrayOptions = new Array<NavOptions>()
        arrayOptions.push({
            title: "Arquivos Digitais (Documentos)",
            action: (navigation: any, item: any, component: React.Component) => this.routerDocuments(navigation, item),
            isSelection: true
        })

        arrayOptions.push({
            title: "Movimentar Processo",
            action: (navigation: any, item: any, component: React.Component) => this.routerMovement(navigation, item, component),
            isSelection: true
        })

        arrayOptions.push({
            title: "Subprocessos",
            action: (navigation: any, item: any, component: React.Component) => this.routerSubprocess(navigation, item, component),
            isSelection: true
        })

        arrayOptions.push({
            title: "Visitas",
            action: (navigation: any, item: any, component: React.Component) => this.routerVisit(navigation, item, component),
            isSelection: true
        })

        var viewModel = new TableGenericViewModel("gepprocessoadministrativo")
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.*']} path="/:base/processo-administrativo/:id/subprocessos" exact={true} component={(props: any) => {
            var idFk = props.match.params.id
            var filter = new TableGenericFilter('Origem', idFk)
            return (<TableGenericViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Processo Administrativo"}
                options={arrayOptions}
                filter={[filter]}
            />)
        }} />)
    }

    private routeFormChildreen(): JSX.Element {
        var viewModel = new AdminProcessViewModel()
        return (<ProtectedRoute requiredPermissions={['proc_admin.proc_admin.adicionar', 'proc_admin.proc_admin.editar']} path="/:base/processo-administrativo/:origem/subprocessos/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            var idFk = props.match.params.origem
            return (<AdminProcessViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idProcessAdmin={idFk}
            />)
        }} />)
    }

    routerDocuments(navigation: any, item: any) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/processo-administrativo/${item}/arquivos`);
    }

    routerMovement(navigation: any, item: any, component: React.Component) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/processo-administrativo/${item}/movimentacoes`);
    }

    routerSubprocess(navigation: any, item: any, component: React.Component) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/processo-administrativo/${item}/subprocessos`);
        window.location.reload()
    }

    routerVisit(navigation: any, item: any, component: React.Component) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/processo-administrativo/${item}/visita`);
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack()
        setTimeout(() => {
            window.location.reload()
        }, 500);
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        var filter = viewModel.getFilter()
        if (viewModel.getTable() == "gepprocessoadministrativo" && filter == undefined) {
            navigation.history.push(`processo-administrativo/cad/0`);
            return;
        }

        if (filter && filter.length == 1) {
            var database = localStorage.getItem('database')
            navigation.history.push(`/${database}/processo-administrativo/${filter[0].getValue()}/subprocessos/cad/0`);
            return;
        }

        if (filter && filter.length == 2) {
            var database = localStorage.getItem('database')
            var typeFk = ""
            if (filter[1].getColumn() == "Shape") {
                typeFk = "shape"
            } else if (filter[1].getColumn() == "Propriedade") {
                typeFk = "propriedade"
            } else if (filter[1].getColumn() == "Edificação") {
                typeFk = "edificacao"
            }

            navigation.history.push(`/${database}/${typeFk}/${filter[1].getValue()}/processo-administrativo/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        var filter = viewModel.getFilter()
        if (viewModel.getTable() == "gepprocessoadministrativo" && filter == undefined) {
            navigation.history.push(`processo-administrativo/cad/${idSelection}`);
            return;
        }

        if (filter && filter.length == 1) {
            var database = localStorage.getItem('database')
            navigation.history.push(`/${database}/processo-administrativo/${filter[0].getValue()}/subprocessos/cad/${idSelection}`);
            return;
        }

        if (filter && filter.length == 2) {
            var database = localStorage.getItem('database')
            var typeFk = ""
            if (filter[1].getColumn() == "Shape") {
                typeFk = "shape"
            } else if (filter[1].getColumn() == "Propriedade") {
                typeFk = "propriedade"
            } else if (filter[1].getColumn() == "Edificação") {
                typeFk = "edificacao"
            }

            navigation.history.push(`/${database}/${typeFk}/${filter[1].getValue()}/processo-administrativo/cad/${idSelection}`);
            return;
        }
    }

}